import { useAuthContext } from '~/shared/context/useAuthContext';
import { useOrganizationStatus } from '~/shared/utils/organizationUtils';
import PageContainer from '~/shared/components/PageContainer';

import { RoleArnOrganization } from './components/RoleArnOrganization';
import { RoleArn } from './components/RoleArn';

export default function PermissionsPage() {
  const { accounts, activeTenantId } = useAuthContext();
  const { isOrganizationAccount } = useOrganizationStatus(accounts, activeTenantId);

  return (
    <PageContainer className="px-[30px]">
      {isOrganizationAccount ? (
        <RoleArnOrganization />
      ) : (
        <RoleArn />
      )}
    </PageContainer>
  );
}
